import React, { Component } from 'react';
import { MapPin } from 'lucide-react';
export function SeoDescriptionSection() {
  return <section className="bg-gray-50 py-16 md:py-20 border-t border-gray-200" data-id="element-505">
      <div className="max-w-4xl mx-auto px-4" data-id="element-506">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-507">
          Industrial Bearings & Power Transmission Components — In Stock & Ready
          to Ship
        </h2>

        <div className="prose prose-gray max-w-none text-gray-700 leading-relaxed space-y-6" data-id="element-508">
          <p data-id="element-509">
            USA Bearings & Belts is a nationwide supplier of industrial
            bearings, belts, chain, sprockets, and power transmission
            components, serving OEMs, maintenance teams, and commercial buyers
            across the United States and beyond. With distribution locations
            throughout the country, we help customers source critical motion
            components quickly and reliably.
          </p>

          <p data-id="element-510">
            Our inventory includes mounted bearing units such as pillow blocks
            and flanged bearings, roller chain in steel and stainless steel,
            sprockets, pulleys, shaft collars, electric motors, and gear
            reducers. We support standard replacements as well as bulk and OEM
            orders, including volume pricing and assistance with engineered or
            custom needs.
          </p>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-300 flex items-center justify-center gap-2 text-gray-600" data-id="element-511">
          <MapPin className="w-5 h-5 text-red-600 flex-shrink-0" data-id="element-512" />
          <p className="font-medium" data-id="element-513">
            <span className="text-gray-900" data-id="element-514">Headquarters:</span> 8012 118th Ave
            N, Largo, Florida 33773
          </p>
        </div>
      </div>
    </section>;
}